import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import './RecordTypeNav.css';

const links = [
  { type: 'rfq', label: 'RFQs', path: '/rfq' },
  { type: 'order', label: 'Orders', path: '/order' }
];

class RecordTypeNav extends Component {
  render() {
    return (<div className="RecordTypeNav">
      {links.map(l => this.renderLink(l))}
    </div>);
  }

  renderLink(link) {
    return (<NavLink
      key={link.type}
      to={link.path}
      className={classnames('RecordTypeNav-link', link.type)}
      activeClassName="selected"
    >{link.label}</NavLink>);
  }
}

export default RecordTypeNav;



// WEBPACK FOOTER //
// ./src/home/RecordTypeNav.js